import React from 'react';
import styles from './Spinner.module.css';

type SpinnerProps = {
  size?: 'small' | 'medium' | 'large';
  className?: string;
};

export const Spinner: React.FC<SpinnerProps> = ({ size = 'medium', className = '' }) => {
  const sizeClasses = {
    small: styles.small,
    medium: styles.medium,
    large: styles.large,
  };

  return (
    <div className={`${styles.spinner} ${sizeClasses[size]} ${className}`}>
      <div className={styles.spinnerInner}></div>
    </div>
  );
};